import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // 1. IMPORTAR HOOK
import { 
  Phone, Mail, MapPin, Facebook, Linkedin, MessageCircle, ArrowRight, Loader2, CalendarCheck, Instagram 
} from 'lucide-react';

const Contacto = ({ language }) => { // Ya no recibimos navigateTo
   
   // 2. INICIALIZAR HOOK
   const navigate = useNavigate();

   // Estados para el formulario
   const [formData, setFormData] = useState({
      nombre: '',
      empresa: '',
      celular: '',
      email: '',
      asunto: '', 
      mensaje: ''
   });
   const [status, setStatus] = useState('idle');

   // --- DICCIONARIO DE TEXTOS ---
   const t = {
      es: {
          tag: '¿Hablamos?',
          titleMain: 'Conectemos tu',
          titleSpan: 'Empresa',
          subtitle: 'Estamos listos para optimizar tu gestión humana. Escríbenos, visítanos o agenda una cita.',
          infoTitle: 'Información de Contacto',
          labelCall: 'Llámanos',
          labelWrite: 'Escríbenos',
          labelLoc: 'Ubicación',
          locText: 'Medellín, Bogotá & Cali',
          locSub: 'Cobertura total en el Valle de Aburrá',
          scheduleTitle: 'Agenda una Cita',
          scheduleDesc: 'Reserva un espacio con nuestros consultores expertos.',
          scheduleBtn: 'Ver Disponibilidad',
          fName: 'Nombre',
          fNamePh: 'Tu nombre completo',
          fCompany: 'Empresa',
          fCompanyPh: 'Nombre de tu empresa',
          fPhone: 'Celular',
          fEmail: 'Email Corporativo',
          fSubject: '¿Qué necesitas?',
          fSubjectPh: 'Solicitar Cotización...', // Placeholder
          fMsg: 'Mensaje',
          fMsgPh: 'Cuéntanos más sobre tu necesidad...',
          btnSend: 'Enviar Mensaje',
          btnSending: 'Enviando...',
          success: '¡Mensaje enviado con éxito! Te contactaremos pronto.',
          error: 'Hubo un error al enviar. Por favor intenta nuevamente o escríbenos al WhatsApp.',
          policyPre: 'Al enviar este formulario aceptas nuestra',
          policyLink: 'política de tratamiento de datos',
          optSST: 'Outsourcing SST (Seguridad y Salud)',
          optRRHH: 'Outsourcing RR.HH.',
          optRecruitment: 'Selección de Personal',
          optStructure: 'Estructura Organizacional',
          optInnovation: 'Innovación Empresarial',
          optPayroll: 'Outsourcing de Nómina',
          optLegal: 'Asesoría Jurídica',
          optIndependent: 'Servicios Independientes',
          optOther: 'Otro / Consulta General'
      },
      en: {
          tag: "Let's Talk?",
          titleMain: "Let's Connect Your",
          titleSpan: 'Company',
          subtitle: 'We are ready to optimize your human management. Write to us, visit us, or book an appointment.',
          infoTitle: 'Contact Information',
          labelCall: 'Call Us',
          labelWrite: 'Write Us',
          labelLoc: 'Location',
          locText: 'Medellín, Bogotá & Cali',
          locSub: 'Total coverage in Aburrá Valley',
          scheduleTitle: 'Book an Appointment',
          scheduleDesc: 'Reserve a slot with our expert consultants.',
          scheduleBtn: 'Check Availability',
          fName: 'Name',
          fNamePh: 'Your full name',
          fCompany: 'Company',
          fCompanyPh: 'Your company name',
          fPhone: 'Phone',
          fEmail: 'Corporate Email',
          fSubject: 'What do you need?',
          fMsg: 'Message',
          fMsgPh: 'Tell us more about your need...',
          btnSend: 'Send Message',
          btnSending: 'Sending...',
          success: 'Message sent successfully! We will contact you soon.',
          error: 'There was an error sending. Please try again or write to us on WhatsApp.',
          policyPre: 'By sending this form you accept our',
          policyLink: 'data processing policy',
          optSST: 'SST Outsourcing (Health & Safety)',
          optRRHH: 'HR Outsourcing',
          optRecruitment: 'Recruitment',
          optStructure: 'Organizational Structure',
          optInnovation: 'Business Innovation',
          optPayroll: 'Payroll Outsourcing',
          optLegal: 'Legal Advice',
          optIndependent: 'Independent Services',
          optOther: 'Other / General Inquiry'
      }
   };

   const text = t[language] || t.es;

   const handleChange = (e) => {
      setFormData({ ...formData, [e.target.name]: e.target.value });
   };

   const handleSubmit = async (e) => {
      e.preventDefault();
      setStatus('loading');

      // ID del formulario obtenido de tu error log (7718)
      const formId = '7718'; 

      const data = new FormData();
      // Campos visibles (tus datos)
      data.append('your-name', formData.nombre);
      data.append('your-company', formData.empresa);
      data.append('your-phone', formData.celular);
      data.append('your-email', formData.email);
      data.append('your-subject', formData.asunto);
      data.append('your-message', formData.mensaje);

      // --- CORRECCIÓN CLAVE PARA ERROR UNIT TAG ---
      // Campos ocultos requeridos por Contact Form 7
      data.append('_wpcf7', formId);
      data.append('_wpcf7_version', '5.9'); // Versión compatible
      data.append('_wpcf7_locale', 'es_ES');
      data.append('_wpcf7_unit_tag', `wpcf7-f${formId}-p1-o1`); // Tag único simulado
      data.append('_wpcf7_container_post', '0'); 
      // ----------------------------------------------

      try {
         const siteUrl = window.zaphyData?.siteUrl || 'https://zaphy.com.co'; 
         
         const response = await fetch(`${siteUrl}/wp-json/contact-form-7/v1/contact-forms/${formId}/feedback`, {
            method: 'POST',
            body: data
         });

         const result = await response.json();

         if (result.status === 'mail_sent') {
            setStatus('success');
            setFormData({ nombre: '', empresa: '', celular: '', email: '', asunto: '', mensaje: '' });
            setTimeout(() => setStatus('idle'), 5000);
         } else {
            setStatus('error');
            console.error('Error CF7 Detallado:', result);
         }
      } catch (error) {
         console.error('Error de red:', error);
         setStatus('error'); 
         setTimeout(() => setStatus('idle'), 5000);
      }
   };

   return (
      <div className="pt-32 pb-20 bg-gray-50 min-h-screen animate-[fadeIn_0.5s_ease-out] relative overflow-hidden">
         {/* Decoración de fondo */}
         <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-purple-600/5 rounded-full blur-[100px] -mr-32 -mt-32"></div>
         <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-cyan-600/5 rounded-full blur-[100px] -ml-32 -mb-32"></div>
   
         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
            
            <div className="text-center mb-16">
               <span className="text-cyan-600 font-bold tracking-[0.2em] uppercase text-xs mb-3 block font-[Poppins]">{text.tag}</span>
               <h2 className="text-4xl sm:text-6xl font-extrabold text-gray-900 mb-6 font-[Poppins]">
                  {text.titleMain} <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-cyan-500">{text.titleSpan}</span>
               </h2>
               <p className="text-xl text-gray-500 max-w-2xl mx-auto font-[Poppins]">
                  {text.subtitle}
               </p>
            </div>
   
            <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-start">
               
               {/* Columna Izquierda: Agendamiento + Información de Contacto */}
               <div className="lg:col-span-2 space-y-8 flex flex-col">
                   
                   {/* Tarjeta de Agendamiento */}
                   <div className="bg-white rounded-[30px] p-8 shadow-lg border border-purple-100 relative overflow-hidden group hover:border-purple-300 transition-colors order-1">
                      <div className="absolute top-0 right-0 w-24 h-24 bg-purple-50 rounded-bl-full -mr-4 -mt-4 transition-transform group-hover:scale-110"></div>
                      <div className="relative z-10 flex flex-col items-start">
                          <div className="bg-purple-100 p-3 rounded-2xl text-purple-600 mb-4">
                              <CalendarCheck size={32} />
                          </div>
                          <h3 className="text-xl font-bold text-gray-900 mb-2 font-[Poppins]">{text.scheduleTitle}</h3>
                          <p className="text-gray-500 text-sm mb-6">{text.scheduleDesc}</p>
                          <a 
                             href="https://calendar.app.google/UYZ2ERubo552yRg19" 
                             target="_blank" 
                             rel="noopener noreferrer"
                             className="w-full bg-purple-600 text-white font-bold py-3 rounded-xl text-center hover:bg-purple-700 transition-colors flex items-center justify-center gap-2"
                          >
                             {text.scheduleBtn} <ArrowRight size={18}/>
                          </a>
                      </div>
                   </div>

                   {/* Tarjeta Principal de Contacto */}
                   <div className="bg-gradient-to-br from-purple-900 to-indigo-900 rounded-[40px] p-10 text-white shadow-2xl relative overflow-hidden transform hover:scale-[1.02] transition-transform duration-500 order-2">
                      <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full blur-3xl -mr-16 -mt-16"></div>
                      <div className="absolute bottom-0 left-0 w-40 h-40 bg-cyan-500/20 rounded-full blur-2xl -ml-10 -mb-10"></div>
                      
                      <h3 className="text-2xl font-bold mb-8 font-[Poppins] relative z-10">{text.infoTitle}</h3>
                      
                      <div className="space-y-8 relative z-10">
                          <div className="flex items-start gap-5">
                             <div className="bg-white/10 p-3 rounded-2xl backdrop-blur-sm border border-white/10"><Phone size={24} className="text-cyan-400"/></div>
                             <div>
                                <p className="text-purple-200 text-xs font-bold uppercase mb-1 tracking-wider">{text.labelCall}</p>
                                <p className="text-xl font-bold font-[Poppins]">311 404 4203</p>
                                <p className="text-lg opacity-80 font-[Poppins]">300 750 3796</p>
                             </div>
                          </div>
                          
                          <div className="flex items-start gap-5">
                             <div className="bg-white/10 p-3 rounded-2xl backdrop-blur-sm border border-white/10"><Mail size={24} className="text-cyan-400"/></div>
                             <div>
                                <p className="text-purple-200 text-xs font-bold uppercase mb-1 tracking-wider">{text.labelWrite}</p>
                                <p className="text-lg break-all font-[Poppins]">comercial@zaphy.com.co</p>
                             </div>
                          </div>
       
                          <div className="flex items-start gap-5">
                             <div className="bg-white/10 p-3 rounded-2xl backdrop-blur-sm border border-white/10"><MapPin size={24} className="text-cyan-400"/></div>
                             <div>
                                <p className="text-purple-200 text-xs font-bold uppercase mb-1 tracking-wider">{text.labelLoc}</p>
                                <p className="text-lg font-[Poppins]">{text.locText}</p>
                                <p className="text-sm opacity-80 mt-1 font-[Poppins]">{text.locSub}</p>
                             </div>
                          </div>
                      </div>
       
                      <div className="mt-12 pt-8 border-t border-white/10 flex gap-4 relative z-10">
                          <a href="https://www.facebook.com/zaphygestionintegral" target="_blank" rel="noopener noreferrer" className="bg-white/5 p-3 rounded-full hover:bg-white/20 transition-all hover:scale-110"><Facebook size={20}/></a>
                          <a href="https://www.linkedin.com/company/zaphy-gestion-integral" target="_blank" rel="noopener noreferrer" className="bg-white/5 p-3 rounded-full hover:bg-white/20 transition-all hover:scale-110"><Linkedin size={20}/></a>
                          <a href="https://www.instagram.com/zaphygestionintegral/" target="_blank" rel="noopener noreferrer" className="bg-white/5 p-3 rounded-full hover:bg-white/20 transition-all hover:scale-110"><Instagram size={20}/></a>
                          <a href="https://wa.me/573114044203" target="_blank" rel="noopener noreferrer" className="bg-white/5 p-3 rounded-full hover:bg-white/20 transition-all hover:scale-110"><MessageCircle size={20}/></a>
                      </div>
                   </div>
               </div>
   
               {/* Columna Derecha: Formulario Interactivo */}
               <div className="lg:col-span-3 bg-white rounded-[40px] p-8 sm:p-12 shadow-[0_20px_50px_rgba(0,0,0,0.05)] border border-gray-100 relative h-full">
                  <form className="space-y-6" onSubmit={handleSubmit}>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                         <div className="group">
                            <label className="block text-sm font-bold text-gray-700 mb-2 font-[Poppins] ml-1">{text.fName}</label>
                            <input 
                               type="text" 
                               name="nombre"
                               value={formData.nombre}
                               onChange={handleChange}
                               required
                               className="w-full bg-gray-50 border border-gray-200 rounded-2xl p-4 focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all group-hover:bg-white group-hover:shadow-md" 
                               placeholder={text.fNamePh} 
                            />
                         </div>
                         <div className="group">
                            <label className="block text-sm font-bold text-gray-700 mb-2 font-[Poppins] ml-1">{text.fCompany}</label>
                            <input 
                               type="text" 
                               name="empresa"
                               value={formData.empresa}
                               onChange={handleChange}
                               className="w-full bg-gray-50 border border-gray-200 rounded-2xl p-4 focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all group-hover:bg-white group-hover:shadow-md" 
                               placeholder={text.fCompanyPh} 
                            />
                         </div>
                      </div>
   
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                         <div className="group">
                            <label className="block text-sm font-bold text-gray-700 mb-2 font-[Poppins] ml-1">{text.fPhone}</label>
                            <input 
                               type="tel" 
                               name="celular"
                               value={formData.celular}
                               onChange={handleChange}
                               required
                               className="w-full bg-gray-50 border border-gray-200 rounded-2xl p-4 focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all group-hover:bg-white group-hover:shadow-md" 
                               placeholder="300 123 4567" 
                            />
                         </div>
                         <div className="group">
                            <label className="block text-sm font-bold text-gray-700 mb-2 font-[Poppins] ml-1">{text.fEmail}</label>
                            <input 
                               type="email" 
                               name="email"
                               value={formData.email}
                               onChange={handleChange}
                               required
                               className="w-full bg-gray-50 border border-gray-200 rounded-2xl p-4 focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all group-hover:bg-white group-hover:shadow-md" 
                               placeholder="hola@empresa.com" 
                            />
                         </div>
                      </div>
   
                      <div className="group">
                         <label className="block text-sm font-bold text-gray-700 mb-2 font-[Poppins] ml-1">{text.fSubject}</label>
                         <select 
                            name="asunto"
                            value={formData.asunto}
                            onChange={handleChange}
                            required
                            className={`w-full bg-gray-50 border border-gray-200 rounded-2xl p-4 focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all cursor-pointer hover:bg-white hover:shadow-md ${formData.asunto === '' ? 'text-gray-400' : 'text-gray-700'}`}
                         >
                            <option value="" disabled>{text.fSubjectPh}</option>
                            <option value="SST">{text.optSST}</option>
                            <option value="RRHH">{text.optRRHH}</option>
                            <option value="Seleccion">{text.optRecruitment}</option>
                            <option value="Estructura">{text.optStructure}</option>
                            <option value="Innovacion">{text.optInnovation}</option>
                            <option value="Nomina">{text.optPayroll}</option>
                            <option value="Juridico">{text.optLegal}</option>
                            <option value="Independientes">{text.optIndependent}</option>
                            <option value="Otro">{text.optOther}</option>
                         </select>
                      </div>
   
                      <div className="group">
                         <label className="block text-sm font-bold text-gray-700 mb-2 font-[Poppins] ml-1">{text.fMsg}</label>
                         <textarea 
                            name="mensaje"
                            value={formData.mensaje}
                            onChange={handleChange}
                            required
                            className="w-full bg-gray-50 border border-gray-200 rounded-2xl p-4 h-32 focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all resize-none group-hover:bg-white group-hover:shadow-md" 
                            placeholder={text.fMsgPh}
                         ></textarea>
                      </div>
   
                      <button 
                         type="submit" 
                         disabled={status === 'loading'}
                         className={`w-full bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 text-white font-bold py-5 rounded-2xl shadow-xl hover:shadow-purple-500/30 transition-all text-lg font-[Poppins] flex items-center justify-center gap-3 transform hover:-translate-y-1 ${status === 'loading' ? 'opacity-70 cursor-not-allowed' : ''}`}
                      >
                         {status === 'loading' ? (
                            <>Enviando... <Loader2 className="animate-spin" size={22}/></>
                         ) : (
                            <>{text.btnSend} <ArrowRight size={22}/></>
                         )}
                      </button>
                      
                      {status === 'success' && (
                         <div className="mt-4 p-4 bg-green-50 text-green-700 rounded-xl text-center font-bold border border-green-200 animate-pulse">
                            {text.success}
                         </div>
                      )}
                      
                      {status === 'error' && (
                         <div className="mt-4 p-4 bg-red-50 text-red-700 rounded-xl text-center font-bold border border-red-200">
                            {text.error}
                         </div>
                      )}
                      
                      <p className="text-center text-xs text-gray-400 mt-4">
                         {text.policyPre} 
                         {/* 3. CAMBIO: navigateTo -> navigate */}
                         <button type="button" onClick={() => navigate('/politica')} className="underline hover:text-purple-600 bg-transparent border-0 p-0 cursor-pointer ml-1">
                             {text.policyLink}
                         </button>.
                      </p>
                  </form>
               </div>
            </div>
         </div>
      </div>
   );
};

export default Contacto;